import { getSourceType } from 'utils/getSourceType'

const storage: Storage = getSourceType() === 'super_app' ? sessionStorage : localStorage

const setJWTTokens = ({ access, refresh }: { access: string; refresh: string }) => {
  storage.setItem('access_token', access)
  storage.setItem('refresh_token', refresh)
}

const getJWTTokens = () => ({
  access_token: storage.getItem('access_token'),
  refresh_token: storage.getItem('refresh_token')
})

const getAccessToken = () => storage.getItem('access_token')

const getRefreshToken = () => storage.getItem('refresh_token')

const removeJWTTokens = () => {
  storage.removeItem('access_token')
  storage.removeItem('refresh_token')
}

const TokenService = {
  setJWTTokens,
  getJWTTokens,
  getAccessToken,
  getRefreshToken,
  removeJWTTokens
}

export default TokenService
